var FIGURE = FIGURE || {};

FIGURE.shippingMessage = function() {
	var specialMessageModal = $.cookie('specialmessage');
	if (specialMessageModal == 'read') {
		return;
	} else {
		setTimeout(function(){
			$('#figureMessageModal').modal();
		}, 3000);	
	}	
	$('#figureMessageModal').on('hide.bs.modal', function (event) {
		$.cookie('specialmessage', 'read', { path: '/' });
	});
	$('#figureMessageModal a').click(function() {
		$.cookie('specialmessage', 'read', { path: '/' });
	});
}();

FIGURE.clubLevelSelect = function() {
	if ($(".page-pages-clubs").length || $(".page-club-index").length) {
		$(".club-level-select").on("change", (e) => {
			const select = $(e.target).closest(".club-level-select");
			const selectGroup = select.data("club-group").replace("Join the ", "");
			const optionVal = select.val();
			let optionTitle = "";
			if (optionVal === "") {
				optionTitle = "";
			} else {
				select.find("option").each((i, option) => {
					if ($(option).val() === optionVal) {
						optionTitle = $(option).val() === optionVal ? $(option).text() : '';
					}
				});
			}
			const hrefBase = "/club/register/";
			const newHref = hrefBase + (optionVal.length ? `${optionVal}/` : '');
			const clubStartBtn = select.siblings(".club-start-btn");
			console.log({
				select, optionVal,
				selectGroup, optionTitle,
				hrefBase, newHref,
				clubStartBtn
			});
			clubStartBtn.attr("href", newHref);
			// clubStartBtn.text(`Join the ${selectGroup} ${optionTitle}`);
		});
	}
}();